import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import ContactCardContent from "./ContactActivityCardContent";

interface Props {
  activity: server.dto.ContactActivity
}

const ContactActivityRowCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <ContactCardContent activity={activity} />
  </ActivityCard>;
};

export default ContactActivityRowCard;